if (document.querySelector('.tabs')) {
  const tabs = document.querySelector('.content_section');
  const tabButtons = tabs.querySelectorAll('[role="tab"]');
  const tabPanels = tabs.querySelectorAll('[role="tabpanel"]');

  const metaContent = {
    beauty: {
      title: 'Система онлайн-записи для салонов красоты',
      description: 'Онлайн-запись для салона красоты. Электронная запись к парикмахеру. Автоматизация бизнеса.',
      keywords: 'онлайн запись в салон, автоматизация бизнеса, система онлайн записи'
    },
    medicine: {
      title: 'Система онлайн-записи к врачу',
      description: 'Автоматизация записи для медицинских клиник. Запись на прием к врачу. Онлайн календарь.',
      keywords: 'онлайн запись к врачу, система онлайн записи, автоматизация клиник'
    },
    fitness: {
      title: 'Система онлайн-записи для фитнеса',
      description: 'Онлайн запись Croinc. Автоматизация фитнес цен',
      keywords: 'онлайн запись, croinc, онлайн запись на фитнес, автоматизация бизнеса'
    }
  };


  function handleTabClick(event) {
    tabPanels.forEach(function(panel) {
      panel.hidden = true;
    });

    tabButtons.forEach(function(tab) {
      tab.setAttribute('aria-selected', false);
    });

    event.currentTarget.setAttribute('aria-selected', true);

    const {id} = event.currentTarget;

    const tabPanel = tabs.querySelector(`[aria-labelledby="${id}"]`);
    tabPanel.hidden = false;

    setMetaTags( event.currentTarget.getAttribute('data-cat') );

    document.querySelectorAll('.category_heading').forEach(function (cat) {

        if (cat.getAttribute('data-cat_heading') ===  event.currentTarget.getAttribute('data-cat')) {
          let currentPosition = document.createElement('h1');
          triggerElements(cat, currentPosition);

        } else {
          let prependElement = document.createElement('div');
          triggerElements(cat, prependElement);
        }
    });

  }

  tabButtons.forEach(button => button.addEventListener('click', handleTabClick));

  function initTabs() {
    if(window.location.search.replace('?cat=', '').length > 1 ) {
      let currentParams  = window.location.search.replace('?cat=', '');
      document.querySelectorAll("[data-cat]").forEach(el => el.setAttribute('aria-selected', 'false'));
      document.querySelectorAll("[role=tabpanel]").forEach(el => el.hidden = true);
      let currentCatElement = document.querySelector(`[data-cat=${currentParams}]`);
      let currentCatTabElement = document.querySelector(`[data-tab-cat=${currentParams}]`);
      currentCatElement.setAttribute('aria-selected', 'true');
      currentCatTabElement.hidden = false;

    } else {
      tabPanels.forEach(function(panel, index) {
        panel.hidden =  index !== 0;
      });
      setMetaTags( document.querySelector("[aria-selected=true]").getAttribute('data-cat') );
    }
  }

  initTabs();

  function setMetaTags ( cat ) {
    document.querySelector('title').innerText = metaContent[cat].title;
    document.querySelector('meta[name=description]').content = metaContent[cat].description;
    document.querySelector('meta[name=keywords]').content = metaContent[cat].keywords;
  }

}//


function triggerElements(cat, prependElement) {
  let currentCat = cat.getAttribute('data-cat_heading');
  let  classNames = cat.className;
  prependElement.innerHTML = cat.innerHTML;
  prependElement.classList = classNames;
  prependElement.setAttribute('data-cat_heading', currentCat);
  cat.parentNode.replaceChild(prependElement, cat);
}

